import FlowBpmModelerHost from "../../pages/flowBpm/FlowBpmModelerHost";

const route = {
  key: "flowBpmModeler",
  path: "/flow-bpm-modeler",
  component: FlowBpmModelerHost,
  permission: "flow-bpm.modeler.access",
  private: true,
  layout: "main",
  icon: "faPencilRuler",
  group: "bpm",
  order: 20,
};

export default route;
